export const calcHp = (currentHp: number) => currentHp - 10;

export const generateMessage = (answersArr: string[]) => {
  return answersArr[Math.floor(Math.random() * answersArr.length)]
};
